import Compressor from "compressorjs";
import { encrypt } from "../Services/AESEncryptionDecryption";
import { API_GENERATE_HASH, API_GET_PAYMENT_GATEWAY, API_PATH_PAYU_CREATE_ORDER, API_SAVE_PAYMENT_GATEWAY } from "../Services/endpoints";
import { getApi, postApi } from "../Services/apiService";

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const fileCompress = async (file) => {
  return await new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.6,
      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

export const passwordPattern = () => {
  return [
    {
      required: true,
      message: "Password is required field.",
    },
    {
      min: 8,
      message: "Password must be at least 8 characters long.",
    },

    {
      pattern: new RegExp(/^(?=.*[a-z]).{0,}$/),
      message: "Password must have at least one lowercase ('a'-'z')",
    },
    {
      pattern: new RegExp(/^(?=.*[A-Z]).{0,}$/),
      message: "Password must have at least one uppercase ('A'-'Z')",
    },
    {
      pattern: new RegExp(/^(?=.*[0-9]).{0,}$/),
      message: "Password must have at least one digit ('0'-'9')",
    },
    {
      pattern: new RegExp(
        /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).{0,}$/
      ),
      message:
        'Password must have at least one non alphanumeric character (" !"#$%&\'()*+,-./:;<=>?@[]^_`{|}~")',
    },
  ];
};

export const debounce = (fn, wait) => {
  let timeout;

  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      fn(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const ruppeeConverter = (ruppee) => {
  if (!ruppee) return "0.00";
  ruppee = ruppee.toString();
  var newArr = ruppee.split(".");
  var strArr1 = ruppee.split(".")[0].split("");
  switch (newArr[0].length) {
    case 4:
    case 5:
      strArr1.splice(-3, 0, ",");
      newArr[0] = strArr1.join("");
      ruppee = newArr.join(".");
      break;
    case 6:
    case 7:
      strArr1.splice(-3, 0, ",");
      strArr1.splice(-6, 0, ",");
      newArr[0] = strArr1.join("");
      ruppee = newArr.join(".");
      break;
  }

  return ruppee;
};

export const sumInsuredConverter = (ruppee) => {
  if (!ruppee) return "0";
  ruppee = ruppee.toString();
  let newArr = ruppee.split(".");
  let strArr;
  switch (newArr[0].length) {
    case 5:
      newArr[0] = newArr[0].slice(0, 2);
      ruppee = newArr[0] + " Thousand";
      break;
    case 6:
      newArr[0] = newArr[0].slice(0, 2).split("");
      strArr = newArr[0];
      strArr.splice(1, 0, ".");
      ruppee = strArr.join("") + " Lacs";
      break;
    case 7:
      newArr[0] = newArr[0].slice(0, 2);
      ruppee = newArr[0] + " Lacs";
      break;
    case 8:
      newArr[0] = newArr[0].slice(0, 2).split("");
      strArr = newArr[0];
      strArr.splice(1, 0, ".");
      ruppee = strArr.join("") + " Crores";
      break;
    case 9:
      newArr[0] = newArr[0].slice(0, 2);
      ruppee = newArr[0] + " Crores";
      break;
  }

  return ruppee;
};

export function dateIsValid(dateStr) {
  if (!dateStr) return;
  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  if (dateStr.match(regex) === null) {
    return false;
  }

  const [day, month, year] = dateStr.split("/");

  // 👇️ format Date string as `yyyy-mm-dd`
  const isoFormattedStr = `${year}-${month}-${day}`;

  const date = new Date(isoFormattedStr);

  const timestamp = date.getTime();

  if (typeof timestamp !== "number" || Number.isNaN(timestamp)) {
    return false;
  }

  return date.toISOString().startsWith(isoFormattedStr);
}

export const getURlParameter = (param) => {
  let sPageURl = window.location.search.substring(1);
  let sURLVriable = sPageURl.split("&");
  for (var i = 0; i < sURLVriable.length; i++) {
    let sParameterName = sURLVriable[i].split("=");
    if (sParameterName[0] === param) return sParameterName[1];
  }
};

const doEncryption = (objData) => {
  let encodedObj = {
    encodedString: encrypt(JSON.stringify(objData)),
  };
  return encodedObj
}

export const createPayUOrder = async (reqObj) =>{
  try {
    const encryptReqObj = doEncryption(reqObj)
    const res = await postApi(API_PATH_PAYU_CREATE_ORDER, encryptReqObj,);
     return res.data
  } catch (error) {
    console.error("error in payu create order")
    throw error
  }
}

export const getHashData = async(reqObj) => {
    try {
      const encryptReqObj = doEncryption(reqObj)
      const res = await postApi(API_GENERATE_HASH, encryptReqObj,);
      return res.data
    } catch (error) {
      console.error("error in hash generaterion")
      throw error
    }
  }

export const getPaymentGateway = async (applicationNumber) => {
  const encodedAppNo = encrypt(JSON.stringify(applicationNumber));
  let url = API_GET_PAYMENT_GATEWAY + applicationNumber;
  try {
    const resp = await getApi(url);
    return resp.response
  } catch (error) {
    console.error('error in payment gateway decide')
    throw error
  }
}



export const savePaymentGateway = async (reqObj) => {
  const encodedReqObj = doEncryption(reqObj);
    await postApi(API_SAVE_PAYMENT_GATEWAY, encodedReqObj,)
    .then(function (data) {
      return true;
    })
    .catch(function (error) {
      throw error
    })
}


export const loadScript = () => {
  return new Promise((resolve) => {
    const payUScript = document.createElement("script");
   payUScript.src =  process.env.REACT_APP_API_PAYUP_SCRIPT;

    payUScript.onload = () => {
      resolve(true);
    };
    payUScript.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(payUScript);
  });
};


export const startLoader = () => {
  if (!document.body.classList.contains("loading-indicator-api")) {
    document.body.classList.add("loading-indicator-api");
  }
};

export const hideLoader = () => {
  if (document.body.classList.contains("loading-indicator-api")) {
    document.body.classList.remove("loading-indicator-api");
  }
};